import { render, staticRenderFns } from "./constructor.vue?vue&type=template&id=ccaf2e28"
import script from "./constructor.vue?vue&type=script&lang=ts"
export * from "./constructor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports